import { Form, Button, Alert } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axiosInstance from '../general/axiosInstance';
import { setIsLoading } from '../general/actions';
import { connect } from 'react-redux';
import AlertModal from '../general/alertModal';

function DepartmentUsers(props) {
    const { department, setIsLoading } = props;

    const [userId, setUserId] = useState('');
    const [users, setUsers] = useState([]);
    const [departmentUsers, setDepartmentUsers] = useState([]);
    const [newUser, setNewUser] = useState(null);

    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertModalType, setAlertModalType] = useState('');
    const [alertModalOnConfirm, setAlertModalOnConfirm] = useState(null);
    const [alertModalOnClose, setAlertModalOnClose] = useState(null);

    const asignUser = () => {
        setIsLoading(true);
        axiosInstance.post('users-departments', { user_id: newUser.id, department_id: department })
            .then(response => {
                setDepartmentUsers([...departmentUsers, { ...response.data, user: newUser }]);
                setUserId('');
                setNewUser(null);
            })
            .catch(error => {
                setAlertModalShow(true);
                setAlertModalType('danger');
                setAlertModalMsg(
                    error.response.data.message.includes('Duplicate')
                        ? 'El usuario ya está asignado a este centro de costos'
                        : error.response.data.message
                );
            })
            .finally(() => setIsLoading(false));
    };

    const deleteUserDepartment = (id) => {
        setIsLoading(true);
        axiosInstance.delete('users-departments/' + id)
            .then(() => getDepartmentUsers())
            .catch(console.log)
            .finally(() => setIsLoading(false));
    };

    const getUsers = () => {
        setIsLoading(true);
        axiosInstance.get('users/departments/organizations/current-user')
            .then(res => setUsers(res.data))
            .catch(console.log)
            .finally(() => setIsLoading(false));
    };

    const getDepartmentUsers = () => {
        axiosInstance.get('users-departments/department/' + department)
            .then(res => setDepartmentUsers(res.data))
            .catch(console.log);
    };

    useEffect(() => {
        props.setHasUsers(departmentUsers.length > 0);
    }, [departmentUsers]);

    useEffect(() => {
        getUsers();
        if (department) getDepartmentUsers();
    }, [department]);

    const handleUserChange = (id) => {
        if (!id) return;
        setNewUser(users.find(u => u.id === parseInt(id)));
        setUserId(id);
    };

    if (!department) {
        return (
            <Alert variant="info" style={{ fontSize: 13 }}>
                <i className="fa fa-info-circle" /> Guarda el centro de costos para asignar usuarios.
            </Alert>
        );
    }

    return (
        <>
            <div style={{ marginBottom: 10 }}>
                <Form.Label className="report-field-label">Agregar usuario</Form.Label>
                <div style={{ display: 'flex', gap: 8 }}>
                    <Form.Select size="sm" value={userId} onChange={(e) => handleUserChange(e.target.value)} style={{ flex: 1 }}>
                        <option value="">Seleccione un usuario</option>
                        {users.map(u => (
                            <option key={u.id} value={u.id}>{u.name} — {u.email}</option>
                        ))}
                    </Form.Select>
                    <Button size="sm" variant="primary" disabled={!newUser} onClick={asignUser}>
                        <i className="fa fa-plus" />
                    </Button>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {departmentUsers.length === 0 && (
                    <div style={{ fontSize: 13, color: 'var(--abi-muted)', padding: '8px 0' }}>
                        Sin usuarios asignados
                    </div>
                )}
                {departmentUsers.filter(r => r.user).map(rel => (
                    <div key={rel.id} className="config-user-row">
                        <div className="config-user-info">
                            <div className="user-avatar" style={{ width: 28, height: 28, fontSize: 11 }}>
                                {rel.user.name?.[0]?.toUpperCase() || 'U'}
                            </div>
                            <div>
                                <div style={{ fontSize: 13, fontWeight: 600 }}>{rel.user.name}</div>
                                <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>{rel.user.email}</div>
                            </div>
                        </div>
                        <button className="order-detail-delete-btn" onClick={() => deleteUserDepartment(rel.id)} title="Quitar">
                            <i className="fa fa-times" />
                        </button>
                    </div>
                ))}
            </div>

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                onConfirm={alertModalOnConfirm} setOnConfirm={setAlertModalOnConfirm}
                onClose={alertModalOnClose} setOnClose={setAlertModalOnClose}
                variant={alertModalType}
            />
        </>
    );
}

function mapStateToProps(state) { return { isLoading: state.isLoading }; }
const mapDispatchToProps = { setIsLoading };
export default connect(mapStateToProps, mapDispatchToProps)(DepartmentUsers);
